import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormBuilder, FormArray, FormGroup, FormControl } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from "ng2-bootstrap-modal";
import { PatrimonyModalComponent } from "../../limit-flow-proposal/patrimony-modal/patrimony-modal.component";
import { RevenueModalComponent } from "../../limit-flow-proposal/revenue-modal/revenue-modal.component";
import { saveAs } from 'file-saver';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import 'moment/locale/pt-br';

import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { CommonService } from '../../../../common/service/common.service';

@Component({
	selector: 'app-economic-group-limit',
	templateUrl: './economic-group-limit.component.html',
	styleUrls: ['./economic-group-limit.component.scss'],
	providers: [
		CommonService
	]
})
export class EconomicGroupLimitComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('accountClientID') accountClientID: string = "";
	@Input('tempGroup') tempGroup: any[] = [];
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	revenueRural: FormGroup;
	private token;
	public isGroupAnalysis: boolean = false;
	public selectedGroup: string = "";
	public groupType: number = 0; // 1: Compartilhado | 2: Individual | 3: Relações
	public limiteSugerido: any[] = [];
	public vigenciaSugerida: any[] = [];
	public integrantesDre: any[] = [];

	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.getFullYear()+1, month: this.today.getMonth()+1, day: this.today.getDate()+1},
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()-1},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

	constructor(private fb: FormBuilder, private limitFlowProposalService: LimitFlowProposalService, private dialogService: DialogService, private flashMessagesService: FlashMessagesService, private commonService: CommonService) {
	}

	ngOnInit() {
		this.token = localStorage.getItem('yara.token');
		console.log("Proposta dentro do grupo: ", this.limitFlowProposalService.proposalObj);
		this.isGroupAnalysis = this.limitFlowProposalService.proposalObj['AnaliseGrupo'];
		this.selectedGroup = this.limitFlowProposalService.proposalObj['GrupoEconomicoID'];

		this.validateSelectedGroup();

		for (var key in this.tempGroup) {
			var obj = this.tempGroup[key];
			if (obj.GrupoId === this.selectedGroup) {
				this.groupType = obj.ClassificacaoID;
			}
		}

		console.log(this.limitFlowProposalService.groupMembers);

		if (this.limitFlowProposalService.groupMembers.length < 1) {
			this.getIntegrantes(this.selectedGroup);
		}
	}

	getTotalPatrimonios() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.groupMembers.length; i++) {
			sum += this.limitFlowProposalService.groupMembers[i].PotencialPatrimonial;
		}

		return sum;
	}

	getTotalReceitas(i) {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.groupMembers.length; i++) {
			sum += this.limitFlowProposalService.groupMembers[i].PotencialReceita;
		}

		return sum;
	}

	getDescricao(groupType) {
		var groupDesc = "";
		switch (groupType) {
			case 1:
				groupDesc = "Compartilhado";
				break;

			case 2:
				groupDesc = "Individual";
				break;

			case 3:
				groupDesc = "Relações";
				break;

			default:
				groupDesc = "N/D"
				break;
		}

		return groupDesc;
	}

	setAnalysisType(value) {
		this.limitFlowProposalService.proposalObj['AnaliseGrupo'] = value;
		if (!value) {
			this.selectedGroup = "";
			this.setGroup("");
		}
		else {
			this.validateSelectedGroup();
		}
	}

	setGroup(value) {
		for (var key in this.tempGroup) {
			var obj = this.tempGroup[key];
			if (obj.GrupoId === value) {
				this.groupType = obj.ClassificacaoID;
			}
		}
		this.limitFlowProposalService.proposalObj['GrupoEconomicoID'] = value;
		this.getIntegrantes(value);
	}

	getIntegrantes(value) {
		if (value) {
			this.limitFlowProposalService.getIntegrantes(value).subscribe(result => {
				if (result.Success) {

					this.limitFlowProposalService.groupMembers = result.Result;

					for (var i = 0; i < this.limitFlowProposalService.groupMembers.length; i++) {
						this.vigenciaSugerida[this.limitFlowProposalService.groupMembers[i].Documento] = moment(this.limitFlowProposalService.groupMembers[i].VigenciaSugerida).format("YYYY-MM-DD");
						this.limitFlowProposalService.groupMembers[i].LimiteSugerido = this.limitFlowProposalService.groupMembers[i].LimiteSugerido;
					}

					for (var key in this.limitFlowProposalService.groupMembers) {
						var obj = this.limitFlowProposalService.groupMembers[key];
						this.getPatrimonyByDoc(obj.Documento);
					}

				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			})
		}
	}

	getPatrimonyByDoc(document) {
		let doc = document.replace(/[^\d]+/g, '');

		if (doc.length == 10 || doc.length === 11 || doc.length === 14) {
			this.limitFlowProposalService.getPatrimonusByDocument(doc).subscribe(result => {
				if (result.Success) {
	
					// Preenche os patrimonios do fiador
					var bensRurais = result.Result.BemRural;
					var bensUrbanos = result.Result.BemUrbano;
					var bensMaquinas = result.Result.MaquinasEquipamentos;
					var precosPorRegiao = result.Result.PrecosPorRegiao;
	
					for (var keyRurais in bensRurais) {
						var exists = false;
						var obj = bensRurais[keyRurais];
						if (obj) {
							obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
							obj.GarantiaID = null;
							obj.Documento = document.replace(/[^\d]+/g, '');
							for (var keyRuraisObj in this.limitFlowProposalService.ruralsObj) {
								var objRurals = this.limitFlowProposalService.ruralsObj[keyRuraisObj];
								if (objRurals) {
									if (obj.Documento === objRurals.Documento && obj.IR === objRurals.IR) {
										exists = true;
									}
								}
							}
							if (!exists) {
								this.limitFlowProposalService.ruralsObj.push(obj);
							}
						}
					}
	
					for (var keyUrbanos in bensUrbanos) {
						var exists = false;
						var obj = bensUrbanos[keyUrbanos];
						if (obj) {
							obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
							obj.GarantiaID = null;
							obj.Documento = document.replace(/[^\d]+/g, '');
							for (var keyUrbanosObj in this.limitFlowProposalService.urbansObj) {
								var objUrbans = this.limitFlowProposalService.urbansObj[keyUrbanosObj];
								if (objUrbans) {
									if (obj.Documento === objUrbans.Documento && obj.IR === objUrbans.IR) {
										exists = true;
									}
								}
							}
							if (!exists) {
								this.limitFlowProposalService.urbansObj.push(obj);
							}
						}
					}
	
					for (var keyMaquinas in bensMaquinas) {
						var exists = false;
						var obj = bensMaquinas[keyMaquinas];
						if (obj) {
							obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
							obj.GarantiaID = null;
							obj.Documento = document.replace(/[^\d]+/g, '');
							for (var keyMaquinasObj in this.limitFlowProposalService.machinesObj) {
								var objMachines = this.limitFlowProposalService.machinesObj[keyMaquinasObj];
								if (objMachines) {
									if (obj.Documento === objMachines.Documento && obj.IR === objMachines.IR) {
										exists = true;
									}
								}
							}
							if (!exists) {
								this.limitFlowProposalService.machinesObj.push(obj);
							}
						}
					}
	
					for (var keyPrecos in precosPorRegiao) {
						var exists = false;
						var obj = precosPorRegiao[keyPrecos];
						if (obj) {
							obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
							obj.GarantiaID = null;
							obj.Documento = document.replace(/[^\d]+/g, '');
							for (var keyPrecosObj in this.limitFlowProposalService.priceByRegionObj) {
								var objPrices = this.limitFlowProposalService.priceByRegionObj[keyPrecosObj];
								if (objPrices) {
									if (obj.Documento === objPrices.Documento && obj.Cidade.Nome === objPrices.Cidade.Nome) {
										exists = true;
									}
								}
							}
							if (!exists) {
								this.limitFlowProposalService.priceByRegionObj.push(obj);
							}
						}
					}
	
					var tempMembers = [];
	
					// Atualiza o patrimonio do integrante
					for (var i = 0; i < this.limitFlowProposalService.groupMembers.length; i++) {
						if (this.limitFlowProposalService.groupMembers[i].Documento === document) {
							this.limitFlowProposalService.groupMembers[i].PotencialPatrimonial = result.Result.PotencialPatrimonial;
							this.limitFlowProposalService.groupMembers[i].PotencialReceita = result.Result.PotencialReceita;
						}
	
						var data = {
							PropostaLCID: this.proposalID,
							PotencialPatrimonial: Number(this.limitFlowProposalService.groupMembers[i].PotencialPatrimonial),
							PotencialReceita: Number(this.limitFlowProposalService.groupMembers[i].PotencialReceita),
							Documento: this.limitFlowProposalService.groupMembers[i].Documento
						}
	
						tempMembers.push(data);
					}
	
					$("#integrantesDreDoc").val(JSON.stringify(tempMembers));
	
	
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}
	}

	openPatrimonyIntegral(integrante, index) {
		let disposable = this.dialogService.addDialog(PatrimonyModalComponent, {
			title: "Potencial Patrimônial",
			proposalGuaranteeDocument: integrante.Documento,
			indice: index,
			proposalStatus: this.proposalStatus,
			isUserOwner: this.isUserOwner
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				this.integrantesDre = $("#integrantesDreDoc").val() ? JSON.parse($("#integrantesDreDoc").val().toString()) : [];
				var i = Number($("#tempPotencialPatrimonialIndiceGrupo").val());
				var potencialValue = Number($("#tempPotencialPatrimonialGrupo").val());

				this.limitFlowProposalService.groupMembers[i].PotencialPatrimonial = potencialValue;

				// Caso o integrante seja fiador, atualiza o patrimonio dele
				for (var j = 0; j < this.limitFlowProposalService.guaranteesObj.length; j++) {
					if (this.limitFlowProposalService.guaranteesObj[j].Documento === integrante.Documento.replace(/[^\d]+/g, '')) {
						// Atualiza o fiador (caso exista)
						this.limitFlowProposalService.guaranteesObj[j].PotencialPatrimonial = Number(potencialValue);
					}
				}

				var exists = false;

				if (this.integrantesDre[i]) {
					for (var key in this.integrantesDre) {
						var obj = this.integrantesDre[key];
						if (obj.Documento === this.integrantesDre[i].Documento) {
							this.integrantesDre[i].Documento = this.limitFlowProposalService.groupMembers[i].Documento;
							this.integrantesDre[i].PotencialPatrimonial = Number(potencialValue);
							exists = true;
						}
					}
				}

				if (!exists) {
					var data = {
						PropostaLCID: this.proposalID,
						PotencialPatrimonial: Number(potencialValue),
						PotencialReceita: Number(this.limitFlowProposalService.groupMembers[i].PotencialReceita),
						Documento: this.limitFlowProposalService.groupMembers[i].Documento
					}

					this.integrantesDre.push(data);
				}

				$("#tempPotencialPatrimonialIndiceGrupo").val("");
				$("#tempPotencialPatrimonialGrupo").val("");

				$("#integrantesDreDoc").val(JSON.stringify(this.integrantesDre));

				console.log("Fechei o modal de Patrimonios", isConfirmed);
			});
	}

	openRevenueIntegral(integrante, index) {
		let disposable = this.dialogService.addDialog(RevenueModalComponent, {
			title: "Potencial de Receita",
			proposalRevenueDocument: integrante.Documento,
			indice: index,
			isUserOwner: this.isUserOwner
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				this.integrantesDre = $("#integrantesDreDoc").val() ? JSON.parse($("#integrantesDreDoc").val().toString()) : [];
				var i = Number($("#tempPotencialReceitaIndiceGrupo").val());
				var potencialValue = Number($("#tempPotencialReceitaGrupo").val());

				this.limitFlowProposalService.groupMembers[i].PotencialReceita = potencialValue;

				if (this.integrantesDre[i]) {
					for (var key in this.integrantesDre) {
						var obj = this.integrantesDre[key];
						if (obj.Documento === this.integrantesDre[i].Documento) {
							this.integrantesDre[i].Documento = this.limitFlowProposalService.groupMembers[i].Documento;
							this.integrantesDre[i].PotencialReceita = potencialValue;
						}
					}
				} else {
					var data = {
						PropostaLCID: this.proposalID,
						PotencialReceita: potencialValue,
						Documento: this.limitFlowProposalService.groupMembers[i].Documento
					}

					this.integrantesDre.push(data);
				}

				$("#tempPotencialReceitaIndiceGrupo").val("");
				$("#tempPotencialReceitaGrupo").val("");
				$("#integrantesDreDoc").val(JSON.stringify(this.integrantesDre));

				console.log("Fechei o modal de Receitas", isConfirmed);
			});
	}

	setLimiteSugerido(i) {
		this.integrantesDre = $("#integrantesDreDoc").val() ? JSON.parse($("#integrantesDreDoc").val().toString()) : [];
		//this.limitFlowProposalService.groupMembers[i].LimiteSugerido = value;

		if (this.integrantesDre[i]) {
			for (var key in this.integrantesDre) {
				var obj = this.integrantesDre[key];
				if (obj.Documento === this.integrantesDre[i].Documento) {
					this.integrantesDre[i].LimiteSugerido = this.limitFlowProposalService.groupMembers[i].LimiteSugerido;
					this.integrantesDre[i].Documento = this.limitFlowProposalService.groupMembers[i].Documento;
				}
			}
		} else {
			var data = {
				PropostaLCID: this.proposalID,
				LimiteSugerido: this.limitFlowProposalService.groupMembers[i].LimiteSugerido,
				Documento: this.limitFlowProposalService.groupMembers[i].Documento
			}

			this.integrantesDre.push(data);
		}
		$("#integrantesDreDoc").val(JSON.stringify(this.integrantesDre));
	}

	setVigenciaSugerida(value, i) {
		console.log("a", value);
		var teste = this.limitFlowProposalService.groupMembers[i];
		console.log("a2", teste.VigenciaSugerida);
		this.integrantesDre = $("#integrantesDreDoc").val() ? JSON.parse($("#integrantesDreDoc").val().toString()) : [];
		//this.limitFlowProposalService.groupMembers[i].VigenciaSugerida = this.vigenciaSugerida[this.limitFlowProposalService.groupMembers[i].Documento];

		if (this.integrantesDre[i]) {
			for (var key in this.integrantesDre) {
				var obj = this.integrantesDre[key];
				if (obj.Documento === this.integrantesDre[i].Documento) {
					this.integrantesDre[i].VigenciaSugerida = value ? value.date.year + "-" + value.date.month + "-" + value.date.day : null,
						this.integrantesDre[i].Documento = this.limitFlowProposalService.groupMembers[i].Documento;
					console.log("this.integrantesDre Ja existe", this.integrantesDre);
					console.log("b", value);
				}
			}
		} else {
			var data = {
				PropostaLCID: this.proposalID,
				VigenciaSugerida: value ? value.date.year + "-" + value.date.month + "-" + value.date.day : null,
				Documento: this.limitFlowProposalService.groupMembers[i].Documento
			}

			this.integrantesDre.push(data);
			console.log("c", this.limitFlowProposalService.groupMembers[i].VigenciaSugerida);
			console.log("this.integrantesDre Criando agora", this.integrantesDre);
		}



		$("#integrantesDreDoc").val(JSON.stringify(this.integrantesDre));
	}

	fileSelected(e, i) {
		var input: any = e.target;
		var file = input.files[0];
		this.uploadAttachment(file, i);
	}

	uploadAttachment(file, i) {
		var formData = new FormData();
		formData.append('Arquivo', file);
		formData.append('Tipo', 'PJ');
		this.limitFlowProposalService.insertFinancialDemos(formData).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Template enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });

				this.limitFlowProposalService.groupMembers[i].DemonstrativoID = result.Result.ID;
				this.limitFlowProposalService.groupMembers[i].PotencialCredito = result.Result.PotencialCredito;

				if (this.integrantesDre[i]) {

					for (var key in this.integrantesDre) {
						var obj = this.integrantesDre[key];
						if (obj.Documento === this.integrantesDre[i].Documento) {
							this.integrantesDre[i].DemonstrativoID = result.Result.ID;
							this.integrantesDre[i].Documento = this.limitFlowProposalService.groupMembers[i].Documento;
							this.integrantesDre[i].PotencialCredito = result.Result.PotencialCredito;
						}
					}
				} else {

					var data = {
						DemonstrativoID: result.Result.ID,
						Documento: this.limitFlowProposalService.groupMembers[i].Documento,
						PotencialCredito: result.Result.PotencialCredito,
						PropostaLCID: this.proposalID
					}

					this.integrantesDre.push(data);
				}

				$("#integrantesDreDoc").val(JSON.stringify(this.integrantesDre));

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getDreFile(DemonstrativoID) {
		this.limitFlowProposalService.getDreFile(DemonstrativoID).subscribe(blob => {
			if (blob) {
				saveAs(blob, 'DemonstrativoFinanceiro' + "." + 'xlsm');
			} else {
				this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

	}

	validateSelectedGroup() {
		if (this.isGroupAnalysis == true && (!this.selectedGroup || this.selectedGroup == '')) {
			this.flashMessagesService.show('Em caso de Análise de Grupo, selecione o Grupo', { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/economic-group-limit/economic-group-limit.component.ts